
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/otc",
      function () {
        return require("private-next-pages/otc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/otc"])
      });
    }
  